import { render, staticRenderFns } from "./CampaignTemplateList.vue?vue&type=template&id=8e8a31d2&"
import script from "./CampaignTemplateList.vue?vue&type=script&lang=js&"
export * from "./CampaignTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports